import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { Level } from "../../../../../common/level";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import { reducer } from "../../previewDocuments/RequestPreviewDocumentsPageReducer";
import DocumentUpload from "../upload/DocumentUpload";
import DocumentUploadProgress from "../upload/DocumentUploadProgress";

function SupplementDocs({ pageState, supplement, setIsBlocking, disabled, setSelected }) {
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reducer, pageState);

  return (
    <>
      <div className="block">
        {(supplement || state.supplementDocs.length > 0) && (
          <Divider label={t("requests.reviewDocuments.supplementDocs.divider")} />
        )}

        <DocumentUpload
          isAdditional={false}
          disabled={disabled}
          documents={state.supplementDocs}
          attachments={state.attachments}
          dispatchUpdateAction={() => {
            setIsBlocking(true);
            dispatch({ type: "update-documents" });
          }}
          minDocumentsAttached={state.uploadConstraints.minDocumentsAttached}
          acceptDocumentTypes={state.uploadConstraints.acceptDocumentTypes}
          maxDocumentSizeInMb={state.uploadConstraints.maxDocumentSizeInMb}
          reds={supplement}
          formDataAsJson={{ id: state.request.uid }}
          setSelected={setSelected}
        >
          {state.supplementDocs.length > 0 && (
            <>
              {state.supplementDocs.map((supplementDoc, index) => (
                <Box
                  key={"detail" + index}
                  statusIndicatorPosition="left"
                  statusIndicatorColor={supplementDoc.color}
                  className="is-size-5"
                >
                  <Level>
                    <Level.Side align="left">
                      {index + 1}. {supplementDoc.label}
                    </Level.Side>
                  </Level>
                  <DocumentUploadProgress
                    id={index}
                    doc={supplementDoc.supplement}
                    dispatchUpdateAction={() => {
                      dispatch({
                        type: "update-documents",
                      });
                    }}
                    color={supplementDoc.color}
                    setSelected={setSelected}
                  />
                </Box>
              ))}
            </>
          )}
        </DocumentUpload>
      </div>
    </>
  );
}

export default SupplementDocs;
